<template>
  <div class="flex flex-col">
    <div class="w-full my-8" />
    <div class="w-full md:max-w-sm lg:max-w-md mx-auto">
      <div v-if="account" class="mb-8">
        <img v-if="account.logo" :src="account.logo" class="w-96 mx-auto rounded" />
        <h1 v-else class="text-center">{{ account.name }}</h1>
      </div>
      <LoginForm @success="reloadWindow" />
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/api/client';
import LoginForm from '@/forms/LoginForm.vue';

export default {
  name: 'Login',

  props: {
    accountId: String,
  },

  data() {
    return {
      account: null,
    };
  },

  components: {
    LoginForm,
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      if (!this.accountId) {
        return;
      }

      try {
        const apiFetch = new ApiClient('/api/v1');

        const data = await apiFetch.get(`${this.accountId}/login`);

        this.account = data.data.data;
      } catch (err) {
        //
      }
    },
    reloadWindow() {
      window.location.replace(this.$route.query.redirect_path || '/');
    },
  },
};
</script>
